/**
 * ConversationBubble - Displays Sam's message bubble
 *
 * Wraps ChampionBubble with checkpoint-specific logic:
 * - Loading state with animation
 * - Animation completion callback
 * - Feedback buttons integration
 */
import React from "react"
import { View, StyleSheet } from "react-native"
import Animated, { FadeIn, FadeOut } from "react-native-reanimated"
import ChampionBubble from "../../../../student/champions/ChampionBubble"

/**
 * @param {Object} props
 * @param {Object} props.message - Message object with body and id
 * @param {boolean} props.isLoading - Whether to show loading state
 * @param {number} props.width - Width of the bubble
 * @param {Function} props.onAnimationComplete - Callback when text animation finishes
 * @param {React.ReactNode} props.feedbackButtons - Optional feedback buttons to show
 */
const ConversationBubble = ({
    message,
    isLoading = false,
    width,
    onAnimationComplete,
    feedbackButtons = null
}) => {
    if (isLoading) {
        return (
            <Animated.View
                key="loading"
                entering={FadeIn.duration(300)}
                exiting={FadeOut.duration(200)}
                style={styles.container}
            >
                <ChampionBubble
                    name="sam"
                    variant="main"
                    championPosition="left"
                    texts={[""]}
                    isModal={false}
                    width={width}
                    animated={true}
                    animationKey="loading"
                    isLoading={true}
                />
            </Animated.View>
        )
    }

    if (!message) return null

    return (
        <Animated.View
            key={message.id || "message"}
            entering={FadeIn.duration(300)}
            exiting={FadeOut.duration(200)}
            style={styles.container}
        >
            <ChampionBubble
                name="sam"
                variant="main"
                championPosition="left"
                texts={[message.body]}
                onAnimationComplete={onAnimationComplete}
                isModal={false}
                width={width}
                feedbackButtons={feedbackButtons}
                animated
                animationKey={message.id || "message"}
                isLoading={false}
            />
        </Animated.View>
    )
}

const styles = StyleSheet.create({
    container: {
        width: "100%",
        justifyContent: "flex-start",
        alignItems: "center"
    }
})

export default ConversationBubble
